export * from "./product-comparison-table";
import * as allStyles from "./product-comparison-table.css";

export const styles = allStyles;
